import { ViewSupport44Container } from "../../../containers/SupportSystem/ViewReports/ViewSupport44Container"
export function ViewSupport44Page() {
    return (
        <ViewSupport44Container />
    )
}